import config from 'baseConfig/pg/payments';
import { PAYMENT_VERIFICATION_FILTER, ALL } from 'baseConfig/pg/constants';

const { txStatus, ...otherFilters } = config.All.FILTER_ITEMS;

export default {
  [ALL]: {
    TABLE_COLUMNS: [
      {
        key: 'transactionTime',
        displayName: 'Created At',
        tooltip: {
          message: 'Transaction Added On',
        },
      },
      {
        key: 'orderId',
        displayName: 'Order ID',
      },
      {
        key: 'agentName',
        displayName: 'Agent Name',
      },
      {
        key: 'orderAmount',
        displayName: 'Order Amount',
        align: 'right',
        width: '0.2',
      },
      {
        key: 'refId',
        displayName: 'Payment ID',
        tooltip: {
          message: 'Payment ID',
        },
      },
      {
        key: 'transactionAmount',
        displayName: 'Payment Amount',
        tooltip: {
          message: 'Payment Amount',
        },
        width: '1.8',
        align: 'center',
      },
      {
        key: 'pgUsed',
        displayName: 'PG',
      },
      {
        key: 'gatewayRefId',
        displayName: 'Gateway Ref Name',
        tooltip: {
          message: 'Gateway Ref Name',
        },
      },
      {
        key: 'paymentMode',
        displayName: 'Payment Method',
        tooltip: {
          message: 'Payment Method',
        },
        width: '1.2',
      },
      {
        key: 'txStatus',
        displayName: 'Verification Status',
      },
      {
        key: 'expiryDateTime',
        displayName: '',
      },
    ],
    FILTER_ITEMS: {
      paymentVerification: PAYMENT_VERIFICATION_FILTER,
      txStatus: {
        ...txStatus,
        displayText: 'Payment Status',
      },
      ...otherFilters,
    },

    SEARCH_ITEMS: [...config.All.SEARCH_ITEMS],
  },
};
